import {
  UNICODE_CANONICAL_DECOMPOSITION,
  COMBINING_DIACRITICAL_MARKS,
  APOSTROPHES,
  LOWERCASE_OR_DIGIT_TO_UPPERCASE_BOUNDARY,
  ACRONYM_TO_CAPITALISED_BOUNDARY,
  LETTER_TO_DIGIT_BOUNDARY,
  DIGIT_TO_LETTER_BOUNDARY,
  WORD_SEPARATOR_RUN,
  INSERT_WORD_BOUNDARY,
} from './constants';

/**
 * Applies camelCase casing to a single word based on its position:
 * the first word is lowercased, subsequent words are capitalised
 * (first letter uppercase, rest lowercase).
 * @param {string} word - a single word produced by splitting on WORD_SEPARATOR_RUN
 * @param {number} index - the word's position in the split array
 * @returns {string} - e.g. 'action' for index 0, 'Color' for index > 0
 */
const toCamelCaseWord = (word, index) =>
  index === 0
    ? word.toLowerCase()
    : `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`;

/**
 * Lodash-free equivalent of lodash camelCase.
 * Produces identical output for all --ebl-* colour variable names used as
 * palette keys, including kebab-case (action-color → actionColor),
 * mixed case (miniBanner-hmh-bg → miniBannerHmhBg) and digits (h1 → h1).
 * Does not reproduce lodash for ordinals, multi-char deburr (ß→ss) or
 * astral symbols.
 * @param {string} [value] - e.g. 'action-color'
 * @returns {string} - e.g. 'actionColor'
 */
const camelCase = value =>
  `${value ?? ''}`
    .normalize(UNICODE_CANONICAL_DECOMPOSITION)
    .replace(COMBINING_DIACRITICAL_MARKS, '')
    .replace(APOSTROPHES, '')
    .replace(LOWERCASE_OR_DIGIT_TO_UPPERCASE_BOUNDARY, INSERT_WORD_BOUNDARY)
    .replace(ACRONYM_TO_CAPITALISED_BOUNDARY, INSERT_WORD_BOUNDARY)
    .replace(LETTER_TO_DIGIT_BOUNDARY, INSERT_WORD_BOUNDARY)
    .replace(DIGIT_TO_LETTER_BOUNDARY, INSERT_WORD_BOUNDARY)
    .split(WORD_SEPARATOR_RUN)
    .filter(Boolean)
    .map((word, index) => toCamelCaseWord(word, index))
    .join('');

export default camelCase;
